import { FilterOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { convertDataTypes } from '../../../library/helpers/index.js';
import { CountrySelect, LanguageSelect } from '../../inputs';
import DateRangePicker from '../../inputs/range-picker.jsx';

// Filters for the marketing Project page (subset of ProjectFilterForm).
const ProjectBasicInfoFilterForm = ({ data, ...otherProps }) => {
    const [form] = Form.useForm()

    const clearForm = () => {
        form.setFieldsValue(Object.fromEntries(
            Object.keys(form.getFieldsValue()).map(key => ([key, null]))
        ))
        form.submit()
    }

    const initialValues = {
        ...convertDataTypes(data, {
            country_id: parseInt,
            language_id: parseInt,
        }),
        createdAt: typeof data?.createdAt === 'string'
            ? (() => {
                const range = data.createdAt.split(',').filter(Boolean)
                return range.length ? range : null
            })()
            : data?.createdAt,
    }

    return (
        <Form initialValues={initialValues} form={form} layout='vertical' {...otherProps}>
            <Form.Item name="createdAt" label="Received">
                <DateRangePicker allowClear style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item name='country_id' label="Country">
                <CountrySelect allowClear getPopupContainer={triggerNode => triggerNode.parentElement} />
            </Form.Item>
            <Form.Item name='language_id' label="Language">
                <LanguageSelect allowClear getPopupContainer={triggerNode => triggerNode.parentElement} />
            </Form.Item>
            <div className="actions filter-actions">
                <Button htmlType="submit" type="primary" icon={<FilterOutlined />}>Apply</Button>
                <Button onClick={clearForm} icon={<ReloadOutlined />}>Reset</Button>
            </div>
        </Form>
    )
}

ProjectBasicInfoFilterForm.propTypes = {
    data: PropTypes.object,
}

export default ProjectBasicInfoFilterForm
